<template>
  <div class="baseline-routes-page" style="height: calc(100vh - 135px); overflow: auto; padding-right: 8px;">
    <div class="page-header-row">
      <div class="page-title-wrap">
        <span class="page_title">线路管理</span>
        <span class="page_subtitle">管理偏离监测用的线路及附加点</span>
      </div>
      <div class="header-actions">
        <el-button type="primary" icon="el-icon-plus" size="small" @click="openCreateDialog">
          新建线路
        </el-button>
      </div>
    </div>

    <el-card class="list-card" shadow="never">
      <div slot="header" class="card-header">
        <div class="search-bar">
          <el-input size="small" v-model="searchForm.keyword" placeholder="搜索线路名称 / 编号 / 来源车牌" clearable
            style="width: 320px;" @clear="handleSearch" @keyup.enter.native="handleSearch">
            <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
          </el-input>

          <el-select v-model="searchForm.status" size="small" placeholder="状态" clearable
            style="width: 140px; margin-left: 10px;" @change="handleSearch">
            <el-option label="全部" :value="-1" />
            <el-option label="有效" :value="1" />
            <el-option label="无效" :value="0" />
          </el-select>

          <el-button size="small" icon="el-icon-refresh" @click="handleSearch" style="margin-left: 10px;">刷新</el-button>
        </div>
      </div>

      <el-table v-loading="loading" :data="listData" style="width: 100%;" :max-height="'calc(100vh - 280px)'" border
        highlight-current-row @row-dblclick="openEditDialog">
        <el-table-column type="index" label="#" width="50" align="center" />
        <el-table-column prop="name" label="线路名称" min-width="200" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <div class="route-name-cell">
              <span class="route-name">{{ row.name }}</span>
              <span v-if="row.code" class="route-code">{{ row.code }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="里程" width="100" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.totalLengthKm }} km</span>
          </template>
        </el-table-column>
        <el-table-column label="顶点数" width="80" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.pointCount }}</span>
          </template>
        </el-table-column>

        <el-table-column label="来源车辆" width="130" align="center" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span>{{ row.sourceVehiclePlate || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="附加点数" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag size="mini" type="info" v-if="row.extraPointCount">{{ row.extraPointCount }}</el-tag>
            <span v-else class="muted">0</span>
          </template>
        </el-table-column>
        <el-table-column label="关联任务" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="row.bindingCount ? 'warning' : 'info'" effect="plain">
              {{ row.bindingCount }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="statusText" label="状态" width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="statusTag(row.status)">{{ row.statusText }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="updatedAt" label="更新时间" width="160" align="center" />
        <el-table-column label="操作" width="280" fixed="right" align="center">
          <template slot-scope="{ row }">
            <!-- <el-button size="mini" type="text" @click="openPreviewDialog(row)">预览</el-button> -->
            <el-button size="mini" type="text" @click="openEditDialog(row)">编辑</el-button>


            <el-button size="mini" type="text" style="color: #F56C6C;" @click="confirmDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrap">
        <kl-pagination :total="total" :page-size="pageSize" :current-page.sync="currentPage"
          @current-change="handlePageChange" @size-change="handleSizeChange" />
      </div>
    </el-card>

    <RouteEditDialog :visible.sync="editDialogVisible" :route-id="currentRouteId" @saved="onRouteSaved" />
  </div>
</template>

<script>

import RouteEditDialog from './components/RouteEditDialog.vue';

export default {
  name: 'BaselineRoutes',
  components: { RouteEditDialog },
  data() {
    return {
      loading: false,
      listData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchForm: { keyword: '', status: null },
      editDialogVisible: false,
      currentRouteId: null
    };
  },
  mounted() {
    this.loadList();
  },
  methods: {
    statusTag(s) {
      return s === 1 ? 'success' : s === 2 ? 'danger' : 'info';
    },
    loadList() {
      this.loading = true;
      this.$api.QueryPLRouteInfo({
        QueryData: this.searchForm.keyword || '',   // 线路名称、编号、车牌号
        RouteStatus: this.searchForm.status || -1,        // 1有效 0无效，-1为全部
        PageNo: this.currentPage,
        PageSize: this.pageSize
      }).then(res => {
        if (res.code === 200) {
          this.listData = (res.data || []).map(item => ({
            id: item.RouteID,
            name: item.RouteName,
            code: item.RouteNo,
            totalLengthKm: item.RunMileage,
            pointCount: item.PointCount,
            sourceVehiclePlate: item.CarNo,
            extraPointCount: item.AddPointCount,
            bindingCount: item.TaskCount,
            status: item.RouteStatus,
            statusText: item.RouteStatus === 1 ? '有效' : '无效',
            version: item.RouteVersion,
            updatedAt: item.UpdateTime
          }));
          this.total = res.recordsTotal || 0;
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    handleSearch() {
      this.currentPage = 1;
      this.loadList();
    },
    handlePageChange(p) {
      this.currentPage = p;
      this.loadList();
    },
    handleSizeChange(s) {
      this.pageSize = s;
      this.currentPage = 1;
      this.loadList();
    },
    openCreateDialog() {
      this.currentRouteId = null;
      this.editDialogVisible = true;
    },
    openEditDialog(row) {
      this.currentRouteId = row ? row.id : null;
      this.editDialogVisible = true;
    },
    openPreviewDialog(row) {
      this.$message.info('预览功能请在编辑弹窗中查看地图（该页面弹窗已包含地图预览）');
      this.openEditDialog(row);
    },


    confirmDelete(row) {
      if (row.bindingCount > 0) {
        this.$message.warning('该线路仍有关联任务，需先解除绑定才能删除');
        return;
      }
      this.$confirm(`确定删除线路「${row.name}」？此操作不可恢复。`, '删除确认', {
        confirmButtonText: '删除', cancelButtonText: '取消', type: 'error'
      }).then(() => {
        this.$api.DelPLRouteInfo({ RouteID: row.id }).then(res => {
          if (res.code === 200) {
            this.$message.success('删除成功');
            this.loadList();
          }
        });
      }).catch(() => { });
    },
    onRouteSaved() {
      this.editDialogVisible = false;
      this.loadList();
    }
  }
};
</script>

<style scoped>
.page-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin: 12px 0 16px;
}

.page-title-wrap {
  display: flex;
  align-items: baseline;
}

.page_title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.page_subtitle {
  margin-left: 12px;
  font-size: 12px;
  color: #909399;
}

.header-actions {
  flex-shrink: 0;
}

.list-card {
  margin-bottom: 16px;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
}

.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.route-name-cell {
  display: flex;
  flex-direction: column;
  line-height: 1.4;
}

.route-name {
  color: #303133;
  font-weight: 500;
}

.route-code {
  color: #909399;
  font-size: 12px;
  margin-top: 2px;
}

.muted {
  color: #c0c4cc;
}

.pagination-wrap {
  margin-top: 14px;
  display: flex;
  justify-content: flex-end;
}
</style>
